import { render } from "./Dictionary.vue?vue&type=template&id=5825812a"
import script from "./Dictionary.vue?vue&type=script&lang=js"
export * from "./Dictionary.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__